module.exports = __webpack_public_path__ + "static/img/gzzb.2db0475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gzzb.png
// module id = yuRk
// module chunks = 1